import React, { lazy } from 'react';
import ProtectionWrapper from '../ProtectionWrapper';

/**
 * Lazy-load an assessment page wrapped with content protection
 * (screenshot blocking, copy/select disable, question prompt hardening).
 */
export function lazyWithAssessmentProtection(importFn) {
  return lazy(() =>
    importFn().then((module) => ({
      default: (props) => (
        <ProtectionWrapper>
          <module.default {...props} />
        </ProtectionWrapper>
      ),
    }))
  );
}

export default lazyWithAssessmentProtection;
